<template>
  <div class="relative inline-flex rounded-lg shadow-sm">
    <button
      type="button"
      class="relative inline-flex items-center rounded-l-lg border border-background bg-primary px-3 py-1 text-sm font-medium text-primary-fg hover:bg-primary/70 focus:z-10 focus:outline-none disabled:pointer-events-none"
      :disabled="isLoading"
      @click="onClick(undefined)"
    >
      <slot>Export {{ defaultFileExportFormat }}</slot>
    </button>
    <HeadlessMenu as="div" class="relative -ml-px block">
      <HeadlessMenuButton
        class="relative inline-flex h-full items-center rounded-r-lg border border-background bg-primary p-1 text-sm font-medium text-primary-fg hover:bg-primary/70 focus:z-10 focus:outline-none disabled:pointer-events-none"
        :disabled="isLoading"
      >
        <span class="sr-only">
          open export format options
        </span>
        <IconChevronDown
          class="size-5"
          aria-hidden="true"
        />
      </HeadlessMenuButton>
      <Transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <HeadlessMenuItems
          class="absolute right-0 z-10 -mr-1 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
        >
          <div class="py-1">
            <HeadlessMenuItem
              v-for="option in fileExportFormatOptions"
              :key="option.value"
              #default="{ active }"
            >
              <button
                :class="[
                  active
                    ? 'bg-gray-100 text-gray-900'
                    : 'text-gray-700',
                  'block w-full px-4 py-2 text-left text-sm',
                ]"
                @click="onClick(option.value)"
              >
                Export as {{ option.label }}
              </button>
            </HeadlessMenuItem>
          </div>
        </HeadlessMenuItems>
      </Transition>
    </HeadlessMenu>
    <BaseInnerLoading v-if="isLoading" />
  </div>
</template>
<script setup lang="ts">
import { type FileExportFormat } from "@/composables/options/useFileExportFormatOptions"

const props = defineProps<{
  isLoading?: boolean
  defaultFileExportFormat: FileExportFormat
}>()
const emit = defineEmits<{
  (event: "export", format?: FileExportFormat): void
}>()

const onClick = (value?: FileExportFormat) => {
  emit("export", value)
}

const { options: fileExportFormatOptions } =
  useFileExportFormatOptions()
</script>
